export enum SendToType {
  RESIDENT = 'resident',
  LEAD = 'visitor',
  BOTH = 'both',
  EXTERNAL_LEAD = 'external-lead',
}